import { Link } from 'react-router-dom';

const footerLinks = {
  platform: {
    title: '平台',
    links: [
      { label: '关于蘑菇tv', path: '/about' },
      { label: '主播入驻', path: '#' },
      { label: '帮助中心', path: '#' },
      { label: '社区公约', path: '/article/art4' },
    ],
  },
  product: {
    title: '产品',
    links: [
      { label: '下载App', path: '#' },
      { label: 'TV版', path: '#' },
      { label: '网页版', path: '#' },
      { label: '开放平台', path: '#' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '联系客服', path: '#' },
      { label: '举报中心', path: '#' },
      { label: '安全中心', path: '#' },
      { label: '用户协议', path: '#' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-live-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">
                蘑菇<span className="text-primary-400">tv</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              蘑菇tv是一款专注高清直播与短视频内容的平台，提供海量娱乐、游戏、生活类直播内容。随时随地，畅享优质视频体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-vidicon-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors text-background-300 hover:text-background-50"
                  rel="nofollow"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.path.startsWith('/') ? (
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2020-2026 蘑菇tv 版权所有 | <strong>蘑菇tv直播</strong> - 高清视频直播平台
          </p>
          <div className="flex items-center gap-6 text-sm text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}